var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFeatherEyeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.828,
    height: 22.828,
    viewBox: "0 0 22.828 22.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-eye-off",
    "data-name": "Icon feather-eye-off",
    transform: "translate(-0.086 -0.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_758",
    "data-name": "Trazado 758",
    d: "M16.9,17.6a9.706,9.706,0,0,1-5.4,1.715c-6.364,0-10-6.659-10-6.659A15.808,15.808,0,0,1,6.1,7.715M9.591,6.2A9.022,9.022,0,0,1,11.5,6c6.364,0,10,6.659,10,6.659a15.4,15.4,0,0,1-1.964,2.655m-6.109-.891a2.893,2.893,0,0,1-2.67.717,2.622,2.622,0,0,1-1.968-1.8,2.364,2.364,0,0,1,.783-2.445",
    transform: "translate(0 -1.159)",
    fill: "none",
    stroke: "#b2a169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_759",
    "data-name": "Trazado 759",
    d: "M1.5,1.5l20,20",
    fill: "none",
    stroke: "#b2a169",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFeatherEyeOff);
export default __webpack_public_path__ + "static/media/icon-feather-eye-off.8b868431c4ac43b74ef2a4db59b3e8cb.svg";
export { ForwardRef as ReactComponent };